function initTabsBlock(root = document) {
  // W edytorze (WP 7+) bloki są w iframe – używamy dokumentu/okna elementu
  const doc = root.ownerDocument || root;
  const win = doc.defaultView || window;
  const header = doc.querySelector('header');
  const allTabsBlocks = root.matches?.('.tabs-block')
    ? [root]
    : root.querySelectorAll('.tabs-block');

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  allTabsBlocks.forEach(function (tabsBlock) {
    const navItems = tabsBlock.querySelectorAll('.tabs-block__nav-item');
    // Panele (bloki-dzieci) ACF renderuje osobno – pobieramy je przy każdym użyciu
    const getTabPanels = () =>
      tabsBlock.querySelectorAll('.tabs-block__tab-panel');
    const closeButton = tabsBlock.querySelector('.tabs-block__close-button');
    const contentBlock = tabsBlock.querySelector('.tabs-block__content');

    if (navItems.length === 0) return;

    // --- ZMIANA 1 ---
    // Funkcja otwierająca tab
    function switchTab(index, scroll = true) {
      closeAllTabs(); // Najpierw zamyka wszystko
      contentBlock.style.display = '';
      navItems[index].classList.add('is-active');
      const tabPanels = getTabPanels();
      if (tabPanels[index]) {
        tabPanels[index].classList.add('is-active');
      }

      // Dodaj przewinięcie do góry treści taba
      if (scroll && tabPanels[index]) {
        tabPanels[index].scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }

      // Dodaj blokadę przewijania na mobile
      if (win.innerWidth <= 789) {
        doc.body.style.overflow = 'hidden';
      }
    }

    // --- ZMIANA 2 ---
    // Funkcja zamykająca taby
    function closeAllTabs() {
      navItems.forEach((item) => item.classList.remove('is-active'));
      getTabPanels().forEach((panel) => panel.classList.remove('is-active'));
      contentBlock.style.display = 'none';
      // Zawsze usuwaj blokadę przewijania przy zamykaniu
      doc.body.style.overflow = '';
    }

    function updateContentPosition() {
      if (header && contentBlock) {
        contentBlock.style.top = `${header.offsetHeight}px`;
      }
    }

    // --- ZMIANA 3 ---
    // Funkcja obsługująca resize i stan początkowy
    function handleResizeAndInitialState() {
      // updateContentPosition(); // Możesz odkomentować, jeśli jest potrzebne
      const isMobileView = win.innerWidth <= 789;

      if (isMobileView) {
        closeAllTabs();
      } else {
        // Upewnij się, że po przejściu na desktop scroll jest odblokowany
        doc.body.style.overflow = '';

        const hasActiveTab = tabsBlock.querySelector(
          '.tabs-block__nav-item.is-active'
        );
        if (!hasActiveTab) {
          switchTab(0, false);
        }
      }
    }

    navItems.forEach((navItem, index) => {
      // Podgląd ACF może się renderować wielokrotnie – nie dubluj listenerów
      if (navItem.dataset.tabsBound) return;
      navItem.dataset.tabsBound = 'true';
      navItem.addEventListener('click', (e) => {
        e.preventDefault();
        const isActive = navItem.classList.contains('is-active');

        // Na mobile, kliknięcie aktywnego taba go zamyka (toggle)
        if (win.innerWidth <= 789 && isActive) {
          closeAllTabs();
        } else {
          switchTab(index);
        }
      });
    });

    if (closeButton && !closeButton.dataset.tabsBound) {
      closeButton.dataset.tabsBound = 'true';
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        closeAllTabs();
      });
    }

    handleResizeAndInitialState();
    win.addEventListener(
      'resize',
      debounce(handleResizeAndInitialState, 150)
    );
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initTabsBlock();

  const params = new URLSearchParams(window.location.search);
  const targetId = params.get('tabs-id');
  if (targetId) {
    const targetBtn = document.getElementById(targetId);
    if (targetBtn) {
      targetBtn.click();
    }
  }
});

if (typeof acf !== 'undefined') {
  acf.addAction('render_block_preview/type=tabs', ($block) => {
    initTabsBlock($block[0]);
  });
}
